import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the FoserviceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/


@Injectable()
export class FoserviceProvider {

  constructor(public http: HttpClient) {
    console.log('Hello FoserviceProvider Provider');
  }

  loadInhouseNew(userid, token, serverlocation, icno) {

    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      'client-service': 'insoft-client',
      'auth-key': 'insoftmobile',
      'User-ID': userid,
      'Authorization': token,
      'icno': icno
    });

    // let options = new RequestOptions({ headers: headers });

    //return this.http.get('http://'+serverlocation+"/iservice/dashboard/inhouse",options).map((res: Response) => res.json())
    return this.http.get<any[]>(serverlocation+"/dashboard/inhouse", { headers: header }).map(res => res);
  }

  loadDashboard(userid, token, serverlocation, icno) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadInhouse(userid, token, serverlocation, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/inhouse';


    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadRoomInventory(userid, token, serverlocation, ondate, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "customVar": ondate,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/roominventory';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadArrival(userid, token, serverlocation, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/arrival_today';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }
  loadDeparture(userid, token, serverlocation, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/departure_today';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadCheckout(userid, token, serverlocation, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/checkout_today';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadDashboardDetail(userid, token, serverlocation, icno) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };

    var url = serverlocation + '/dashboard/indexdetail';
    // return response;
    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadDashboardChart(userid, token, serverlocation, icno) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };

    var url = serverlocation + '/dashboard/get_dash_chart';
    // return response;
    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  //Report Statistic MTD (Monthly Occupancy)
  //CI3 route: $route['dashboard/monthly_occupancy']['get'] = 'dashboard/monthly_occupancy';
  loadStatisticMTD(userid, token, serverlocation, icno, dtToCheck?: string) {
    let headers: any = {
      'Content-Type': 'application/json',
      'Client-Service': 'insoft-client',
      'Auth-Key': 'insoftmobile',
      "User-ID": userid,
      "Authorization": token,
      "icno": icno
    };
    if (dtToCheck) {
      headers['dtToCheck'] = dtToCheck;
    }

    let httpOptions = { headers: new HttpHeaders(headers) };

    var url = serverlocation + '/dashboard/monthly_occupancy';
    return new Promise((resolve, reject) => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  //Income Audit MTD (Revenue)
  //CI3 route: $route['dashboard/income_audit_mtd']['get'] = 'dashboard/income_audit_mtd';
  loadIncomeAuditMTD(userid: string, token: string, serverlocation: string, icno: string, dtToCheck?: string) {
    let headers: any = {
      'Content-Type': 'application/json',
      'Client-Service': 'insoft-client',
      'Auth-Key': 'insoftmobile',
      'User-ID': userid,
      'Authorization': token,
      'icno': icno
    };
    if (dtToCheck) {
      headers['dtToCheck'] = dtToCheck;
    }

    let httpOptions = { headers: new HttpHeaders(headers) };

    const url = serverlocation + '/dashboard/income_audit_mtd';
    return new Promise((resolve, reject) => {
      this.http.get(url, httpOptions).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  //Income Audit Today (Revenue Today)
  //CI3 route: $route['dashboard/income_audit_today']['get'] = 'dashboard/income_audit_today';
  loadIncomeAuditToday(userid: string, token: string, serverlocation: string, icno: string, dtToCheck?: string) {
    let headers: any = {
      'Content-Type': 'application/json',
      'Client-Service': 'insoft-client',
      'Auth-Key': 'insoftmobile',
      'User-ID': userid,
      'Authorization': token,
      'icno': icno
    };
    if (dtToCheck) {
      headers['dtToCheck'] = dtToCheck;
    }

    let httpOptions = { headers: new HttpHeaders(headers) };

    const url = serverlocation + '/dashboard/income_audit_today';
    return new Promise((resolve, reject) => {
      this.http.get(url, httpOptions).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  loadTodayOccupancy(userid: string, token: string, serverlocation: string, icno: string, dtToCheck?: string) {
    let headers: any = {
      'Content-Type': 'application/json',
      'Client-Service': 'insoft-client',
      'Auth-Key': 'insoftmobile',
      'User-ID': userid,
      'Authorization': token,
      'icno': icno
    };
    if (dtToCheck) {
      headers['dtToCheck'] = dtToCheck;
    }

    let httpOptions = { headers: new HttpHeaders(headers) };

    const url = serverlocation + '/dashboard/today_occupancy';
    return new Promise((resolve, reject) => {
      this.http.get(url, httpOptions).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  loadSourceOfBooking(userid: string, token: string, serverlocation: string, icno: string, periode: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        'User-ID': userid,
        'Authorization': token,
        'icno': icno,
        'periode': periode
      })
    };

    const url = serverlocation + '/dashboard/source_of_booking';
    return new Promise((resolve, reject) => {
      this.http.get(url, httpOptions).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  loadAvgOccupancyRatio(userid: string, token: string, serverlocation: string, icno: string, dtToCheck?: string) {
    let headers: any = {
      'Content-Type': 'application/json',
      'Client-Service': 'insoft-client',
      'Auth-Key': 'insoftmobile',
      'User-ID': userid,
      'Authorization': token,
      'icno': icno
    };
    if (dtToCheck) {
      headers['dtToCheck'] = dtToCheck;
    }

    let httpOptions = { headers: new HttpHeaders(headers) };

    const url = serverlocation + '/dashboard/avg_occupancy_ratio';
    return new Promise((resolve, reject) => {
      this.http.get(url, httpOptions).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/foservice/foservice.ts